"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Checkmark = _interopRequireDefault(require("@insided/shared/icons/Checkmark"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var getDesktopPhrase = function getDesktopPhrase(signupAllowed, isUserAttending, attendeeCount) {
  if (signupAllowed) {
    if (isUserAttending) {
      if (!attendeeCount) {
        return 'events.attending.you';
      }

      return 'events.attending.you.member';
    }

    return 'events.attending.member';
  }

  if (isUserAttending) {
    if (!attendeeCount) {
      return 'events.attended.you';
    }

    return 'events.attended.you.member';
  }

  return 'events.attended.member';
};

var EventAttendeesPreview = function EventAttendeesPreview(_ref) {
  var _ref$isPastEvent = _ref.isPastEvent,
      isPastEvent = _ref$isPastEvent === void 0 ? false : _ref$isPastEvent,
      attendeeCount = _ref.attendeeCount,
      attendees = _ref.attendees,
      isLoggedInUserAttendee = _ref.isLoggedInUserAttendee,
      isEventEngagementEnabled = _ref.isEventEngagementEnabled;
  if (!isEventEngagementEnabled) return null;
  if (!attendeeCount || !attendees || attendeeCount === 0 || attendees.length === 0) return null;

  if (isLoggedInUserAttendee) {
    attendees = attendees.filter(function (attendee) {
      return attendee.id.toString() !== window.inSidedData.user.userid;
    });
  }

  var desktopCount = isLoggedInUserAttendee && attendeeCount ? attendeeCount - 1 : attendeeCount;
  var desktopPhrase = getDesktopPhrase(!isPastEvent, isLoggedInUserAttendee || false, desktopCount);
  return (0, _preact.h)("div", {
    className: "event-item__attendees"
  }, isLoggedInUserAttendee ? (0, _preact.h)("div", {
    className: "event-item__attendee self"
  }, (0, _preact.h)(_Checkmark.default, {
    width: 24,
    height: 24
  })) : null, attendees.map(function (attendee, i) {
    return (0, _preact.h)("div", {
      key: attendee.name,
      className: (0, _classnames.default)('event-item__attendee', {
        'is-hidden-mobile-only': i + (isLoggedInUserAttendee ? 1 : 0) >= 3
      }, {
        'is-hidden-mobile-up': i + (isLoggedInUserAttendee ? 1 : 0) >= 5
      })
    }, (0, _preact.h)(_UserAvatar.default, {
      user: attendee
    }));
  }), (0, _preact.h)("span", {
    className: "metadata-desktop"
  }, (0, _preact.h)(_phrase.default, {
    p: desktopPhrase,
    m: "Forum",
    count: {
      n: "".concat(desktopCount)
    }
  })), (0, _preact.h)("span", {
    className: "metadata-mobile"
  }, attendeeCount, " ", (0, _preact.h)(_phrase.default, {
    p: "events.attendees",
    m: "Forum"
  })), (0, _preact.h)("span", {
    className: "metadata-featured"
  }, attendeeCount));
};

var _default = EventAttendeesPreview;
exports.default = _default;